<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('userExpeditingDelivery.queryTitle') }}</div>
      </div>
      <div class="">
        <div class="">
          <el-form :inline="true" :model="userExpeditingDeliveryInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input v-model="userExpeditingDeliveryInfo.conditions.cartId"
                :placeholder="$t('userExpeditingDelivery.orderIdPlaceholder')" clearable />
            </el-form-item>
            <el-form-item>
              <el-input v-model="userExpeditingDeliveryInfo.conditions.prodNameLike"
                :placeholder="$t('userExpeditingDelivery.productNamePlaceholder')" clearable />
            </el-form-item>
            <el-form-item>
              <el-input v-model="userExpeditingDeliveryInfo.conditions.personName"
                :placeholder="$t('userExpeditingDelivery.userNamePlaceholder')" clearable />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="_queryOrdersMethod">
                <i class="el-icon-search"></i> {{ $t('common.query') }}
              </el-button>
              <el-button type="primary" size="small" @click="_resetOrdersMethod">
                <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('userExpeditingDelivery.listTitle') }}</div>
      </div>
      <div class="">
        <el-table :data="userExpeditingDeliveryInfo.orderCarts" style="width: 100%" border>
          <el-table-column prop="cartId" :label="$t('userExpeditingDelivery.orderId')" align="center" />
          <el-table-column prop="prodName" :label="$t('userExpeditingDelivery.productName')" align="center" />
          <el-table-column prop="personName" :label="$t('userExpeditingDelivery.userName')" align="center" />
          <el-table-column prop="eventMsg" :label="$t('userExpeditingDelivery.reminderNote')" align="center" />
          <el-table-column prop="createTime" :label="$t('userExpeditingDelivery.reminderTime')" align="center" />
          <el-table-column :label="$t('common.operation')" align="center" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="_openOrderDetailModel(scope.row)">
                {{ $t('userExpeditingDelivery.orderDetail') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          :total="total" layout="total, prev, pager, next, jumper" style="margin-top: 20px; text-align: right" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryStoreOrderCartEvent } from '@/api/goods/userExpeditingDeliveryApi'

export default {
  name: 'UserExpeditingDelivery',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      userExpeditingDeliveryInfo: {
        orderCarts: [],
        conditions: {
          cartId: '',
          personName: '',
          state: '',
          prodNameLike: '',
          shopId: '',
          eventType: '7013',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.userExpeditingDeliveryInfo.conditions.shopId = getShopId()
    this._listOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    async _listOrders(page, rows) {
      this.userExpeditingDeliveryInfo.conditions.page = page
      this.userExpeditingDeliveryInfo.conditions.row = rows
      const params = {
        ...this.userExpeditingDeliveryInfo.conditions,
        cartId: (this.userExpeditingDeliveryInfo.conditions.cartId || '').trim(),
        prodNameLike: (this.userExpeditingDeliveryInfo.conditions.prodNameLike || '').trim(),
        personName: (this.userExpeditingDeliveryInfo.conditions.personName || '').trim()
      }

      try {
        const res = await queryStoreOrderCartEvent(params)
        this.userExpeditingDeliveryInfo.orderCarts = res.data
        this.total = res.records
        this.currentPage = page
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryOrdersMethod() {
      this._listOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetOrdersMethod() {
      this.userExpeditingDeliveryInfo.conditions = {
        cartId: '',
        personName: '',
        state: '',
        prodNameLike: '',
        shopId: getShopId(),
        eventType: '7013',
        page: 1,
        row: 10
      }
      this._listOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _openOrderDetailModel(order) {
      this.$router.push({
        path: '/pages/goods/storeOrderCartDetail',
        query: {
          orderId: order.orderId,
          cartId: order.cartId
        }
      })
    },
    handleCurrentChange(val) {
      this._listOrders(val, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #edf1f2;
  border-image: none;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>